document.addEventListener('DOMContentLoaded', () => {
    // Selectors
    const mainForm = document.querySelector('product-form');
    const stickyContainer = document.querySelector('.sticky-atc-container');
    if (!mainForm || !stickyContainer) {
        return;
    }

    const mainAddToCartButton = mainForm.querySelector('.product-form__submit');
    const mainVariantRadios = mainForm.querySelectorAll('variant-radios input[type="radio"]');
    const stickyVariantRadios = stickyContainer.querySelectorAll('.sticky-variant-picker input[type="radio"]');
    const productVariantsScript = document.querySelector('variant-radios script[type="application/json"]');
    
    if (!productVariantsScript) {
        return;
    }
    const productVariants = JSON.parse(productVariantsScript.textContent);

    const stickyVariantTitle = stickyContainer.querySelector('.sticky-atc-variant-title');
    const stickyPrice = stickyContainer.querySelector('.sticky-atc-price');
    const stickyButton = stickyContainer.querySelector('.sticky-atc-button');
    const stickyImage = stickyContainer.querySelector('.sticky-atc-product-image');
    const mainVariantIdInput = mainForm.querySelector('input[name="id"]');
    
    function getVariantFromSelection(context) {
        const selectedOptions = [];
        const optionPickers = context === mainForm 
            ? mainForm.querySelectorAll('fieldset')
            : stickyContainer.querySelectorAll('.sticky-variant-option');
            
        if (optionPickers.length === 0 && productVariants.length > 0 && productVariants[0].options.length > 1 && productVariants[0].options[0] !== 'Default Title') return null;

        optionPickers.forEach(picker => {
            const checkedRadio = picker.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                selectedOptions.push(checkedRadio.value);
            }
        });
        
        if(productVariants.length === 1) return productVariants[0];

        return productVariants.find(variant => {
            return selectedOptions.every((option, index) => variant.options[index] === option);
        });
    }

    function updateUI(selectedVariant) {
        if (!selectedVariant) {
            stickyButton.setAttribute('disabled', 'disabled');
            stickyButton.querySelector('span').textContent = "Indisponible";
            return;
        }

        mainVariantIdInput.value = selectedVariant.id;

        stickyVariantTitle.textContent = selectedVariant.title;
        const formattedPrice = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(selectedVariant.price / 100);
        stickyPrice.textContent = formattedPrice;

        if (selectedVariant.featured_image) {
            stickyImage.src = selectedVariant.featured_image.src;
        }

        if (selectedVariant.available) {
            stickyButton.removeAttribute('disabled');
            stickyButton.querySelector('span').textContent = "Ajouter au panier";
        } else {
            stickyButton.setAttribute('disabled', 'disabled');
            stickyButton.querySelector('span').textContent = "Épuisé";
        }

        const mainFieldsets = mainForm.querySelectorAll('fieldset');
        mainFieldsets.forEach((fieldset, index) => {
            const radio = fieldset.querySelector(`input[value="${selectedVariant.options[index]}"]`);
            if (radio) radio.checked = true;
        });

        const stickyOptionDivs = stickyContainer.querySelectorAll('.sticky-variant-option');
        stickyOptionDivs.forEach((div, index) => {
            const radio = div.querySelector(`input[value="${selectedVariant.options[index]}"]`);
            if (radio) radio.checked = true;
        });
    }

    mainVariantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            const variant = getVariantFromSelection(mainForm);
            updateUI(variant);
        });
    });

    stickyVariantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            const variant = getVariantFromSelection(stickyContainer);
            updateUI(variant);
        });
    });

    stickyButton.addEventListener('click', () => {
        // The UI is already synced, so we just need to trigger the main form's add-to-cart button.
        mainAddToCartButton.click();
    });

    const showStickyButton = () => {
        if (!mainAddToCartButton) return;
        const mainButtonRect = mainAddToCartButton.getBoundingClientRect();
        if (mainButtonRect.bottom < 0) {
            stickyContainer.classList.add('visible');
        } else {
            stickyContainer.classList.remove('visible');
        }
    };

    window.addEventListener('scroll', showStickyButton);
    showStickyButton();
    const initialVariant = productVariants.find(v => v.id == mainVariantIdInput.value);
    updateUI(initialVariant);
}); 